/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type Page from '@jira/project-settings__board-settings-card/src/CardCoverPage.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyCard: LazyComponent<() => React.JSX.Element> = lazyForPaint<typeof Page>(
	() =>
		import(
			/* webpackChunkName: "async-board-settings-card", jiraSpaEntry: "async-board-settings-card" */ '@jira/project-settings__board-settings-card/src/CardCoverPage.tsx'
		),
);

const AsyncCard = (): React.JSX.Element => (
	<LazyPage Page={LazyCard} pageId="board-settings-card" shouldShowSpinner={false} />
);

export default AsyncCard;
